module.exports = __webpack_public_path__ + "static/media/retirement_on.70f995db.png";